import ScheduledPricesManager from './ScheduledPricesManager'

export default ScheduledPricesManager
